var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-95408ed6-2623-425d-94f3-a4361a3ddcb8",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1bc5555d-3821-45fe-84ab-81e6294aea38",
    d: "M812.93,934.05c0,41.1-33.45,74.55-74.55,74.55H138.45c-41.1,0-74.55-33.45-74.55-74.55V334.14c0-41.1,33.45-74.55,74.55-74.55h299.96v-63.9H138.45C62.11,195.69,0,257.8,0,334.14v599.91c0,76.34,62.11,138.45,138.45,138.45h599.93c76.34,0,138.45-62.11,138.45-138.45v-299.96h-63.9v299.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-1bc5555d-3821-45fe-84ab-81e6294aea38",
    d: "M1042.63,144.13l-99.25-99.25c-49.83-49.83-130.91-49.83-180.74,0l-470,470-45.18,45.18.45.45c-6.12,7.14-11.04,15.37-13.55,24.76l-34.7,129.52-34.7,129.52c-5.91,22.05.4,45.58,16.54,61.72,16.14,16.14,39.67,22.45,61.72,16.54l129.51-34.7,129.52-34.7c9.39-2.52,17.62-7.43,24.76-13.55l.45.45,45.18-45.18,470-470c49.83-49.83,49.83-130.91,0-180.74ZM898.19,90.06l99.25,99.25c24.95,24.95,24.96,65.41,0,90.37l-49.87,49.87-189.62-189.62,49.87-49.87c24.96-24.96,65.41-24.95,90.37,0ZM356.18,826.13l-2.71.73-92.83-92.83.73-2.71,33.25-124.1,185.66,185.66-124.1,33.25ZM436.07,651.44l-94.81-94.81,371.51-371.51,189.62,189.62-371.51,371.51-94.81-94.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.1cb6b748a0ee753450f107d2a2f5f6b9.svg";
export { ForwardRef as ReactComponent };